import React from "react";
import Select from 'react-select';
import storage from "../../Firebase/index";
import {RotateCircleLoading} from 'react-loadingg';

import {MdDelete, MdCallMerge} from 'react-icons/md';

import TicketTableRow from "../../components/Tables/TicketTableRow";
import ClassTableRow from "../../components/Tables/ClassTableRow";
import ticketHelpers from "../../helpers/TiketHelper";
import StudentApiService from "../../api/student-api-service";
import TicketTypeApiService from "../../api/tt-api-service";
import TicketApiService from "../../api/ticket-api-service";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
    Row,
    Table
} from "reactstrap";
// core components
import ClientHeader from "../../components/Headers/ClientHeader.js";
import {Redirect} from "react-router-dom";
import ResourceItem from "../../components/Lists/ResourceItem";
import EditTicketView from "../../components/Resources/Ticket/EditTicketView";
import dateHelpers from "../../helpers/DateHelper";
import constants from "../../shared/constants";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import EditTicketTypeView from "../../components/Resources/EditTicketTypeView";
import ErrorModal from "../../components/Alerts/ErrorModal";
import businessHelper from "../../helpers/BusinessHelper";
import placeholderHelper from "../../helpers/PlaceholderHelper";
import RanksOverview from "../../components/Resources/Student/RanksOverview";
import resourceHelper from "../../helpers/ResourceHelper";
import PartnerSearch from "../../components/Search/PartnerSearch";
import businessApiService from "../../api/business-api-service";
import RewardOverview from "../../components/Resources/Student/RewardOverview";
import RegularClassTypes from "../../components/Resources/Student/RegularClassTypes";
import resourceApiService from "../../api/resource-api-service";
import ChatWindow from "../../components/client/ChatWindow";

const sectionStyle = {
    marginTop: 10,
    marginBottom: 30,
    borderRadius: 10,
    padding: 20,
}

const businessId = businessHelper.business()?.id;

let studentStrings = new LocalizedStrings(student_strings);
let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const centerAll = {display: "flex", alignItems: "center", justifyContent: "center"}

class Student extends React.Component {

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();

        this.state = {
            business: JSON.parse(localStorage.getItem('business')),
            showTickets: false,
            showTicketTypeSelector: false,
            selectedTicketType: null,
            ticketTemplate: null,
            showTicketEditor: false,
            showClasses: false,
            selectedMonth: null,
            studentId: props.location.state.clientId,
            searchValue: props.location.state ? props.location.state.searchValue : null,
            includeDeletedClients: props.location.state ? props.location.state.includeDeletedClients : false,
            backToClass: props.location.state.backToClass,
            backToClassReport: props.location.state.backToClassReport,
            backToUnpaidReport: props.location.state.backToUnpaidReport,
            filters: props.location.state && props.location.state.filters ? props.location.state.filters : null,
            curStudent: null,
            isLoading: true,
            showRanksView: false,
            profileWasUpdated: false,
            file: null,
            blob: null,
            selectedFile: null,
            photoLoading: false,
            formData: {},
            ticketTypes: null,
            showDeletionModal: false,
            ticketToDeleteId: null,
            showTicketTypeEditor: false,
            showError: false,
            error: null,
            backToClients: false,
            smInput: "",
            mustShowRegularClasses: false,
            membership_popup_type: null,
            newMessage: "",
            validation: {
                name: true,
                email: true,
            }
        };

        window.StudentView = this
    }

    componentWillUnmount() {
        window.StudentView = null
    }

    handleSubmit = this.handleSubmit.bind(this);
    handleChange = this.handleChange.bind(this);
    updateTicket = this.updateTicket.bind(this);
    closeTicketView = this.closeTicketView.bind(this);
    goToClass = this.goToClass.bind(this);
    showAddTicketType = this.showAddTicketType.bind(this);
    closeTicketTypeView = this.closeTicketTypeView.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);
    sendEmail = this.sendEmail.bind(this);
    renderRanksModal = this.renderRanksModal.bind(this);
    showSmEditor = this.showSmEditor.bind(this);
    goToClassReport = this.goToClassReport.bind(this);
    goToUnpaidReport = this.goToUnpaidReport.bind(this);
    deleteStudentPhoto = this.deleteStudentPhoto.bind(this);

    sendEmail() {
        this.toggleMessageHistoryView()
    }

    goToClassReport(e) {
        this.setState({goToClassReport: true})
    }

    goToUnpaidReport(e) {
        this.setState({goToUnpaidReport: true})
    }

    onTicketTypeSelected = (e, ticketTypeName) => {
        e.preventDefault();
        const tt = this.state.ticketTypes.filter(tt => {
            return tt.name === ticketTypeName
        })[0];

        this.setState({
            ticketTemplate: ticketHelpers.createTicketTemplate(tt, this.state.studentId),
            showTickets: false,
            showTicketTypeSelector: false,
            showClasses: false,
            selectedTicketType: tt,
            showTicketEditor: true,
        });
    };

    closeTicketTypeSelector(ev) {
        ev.preventDefault();

        this.setState({
            showTickets: true,
            showTicketTypeSelector: false,
        });
    }

    deleteTicket = () => {
        TicketApiService.deleteTicket(this.state.studentId, this.state.ticketToDeleteId)
            .then(res => {
                this.getStudent();
                this.setState({
                    showTicketEditor: false,
                    showDeletionModal: false,
                    showTickets: true,
                    isLoading: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    confirmDeletion = (ticketId) => {
        this.setState({
            showDeletionModal: true,
            ticketToDeleteId: ticketId
        })
    };

    openTicket = (ticketId) => {
        const ticket = this.state.curStudent.tickets.find(t => t.id === ticketId);
        ticket.start = ticket.start ? dateHelpers.databaseDate(new Date(ticket.start)) : null;

        if (ticket.end && ticket.end != constants.open.ENDLESS_TICKET && ticket.end !== "-3") {
            ticket.end = dateHelpers.databaseDate(new Date(ticket.end));
        } else if (!ticket.end && ticket.starts_on_use) {
            ticket.end = null
        } else {
            ticket.end = resourceStrings.unlimited
        }
        this.setState({
            ticketTemplate: ticket,
            selectedTicketType: null,
            showTickets: false,
            showTicketTypeSelector: false,
            showClasses: false,
            showTicketEditor: true,
        });
    };

    showTickets(e) {
        e.preventDefault();

        this.setState({
            showTickets: true,
            showTicketTypeSelector: false,
            showClasses: false,
            showTicketEditor: false,
        });
    }

    showClasses(e) {
        e.preventDefault();

        this.setState({
            showTickets: false,
            showTicketTypeSelector: false,
            showClasses: true,
            showTicketEditor: false,
        })
    }

    handleClick(e) {
        this.fileRef.current.click();
    }

    showEditClient(e) {
        e.preventDefault();

        this.setState({
            showTickets: false,
            showTicketTypeSelector: false,
            showClasses: false,
            showTicketEditor: false,
        })
    }

    handleMonthSelected = selectedOption => {
        this.updateBd(null, selectedOption.value);

        this.setState({
                selectedMonth: selectedOption,
                profileWasUpdated: true
            }
        )
    };

    haraMembershipStart() {
        if (this.state.curStudent && this.state.curStudent.student_notes && this.state.curStudent.student_notes.length > 0) {
            const start = this.state.curStudent.student_notes.find(it => it.tag === "membership_start");
            if (start && start.body) {
                return `Member since: ${dateHelpers.formatDate(new Date(start.body))}`
            }
        }
    }

    haraMembershipEnd() {
        if (this.state.curStudent && this.state.curStudent.student_notes && this.state.curStudent.student_notes.length > 0) {
            const start = this.state.curStudent.student_notes.find(it => it.tag === "membership_end");
            if (start && start.body && start.body.length > 3) {
                return `Member until: ${dateHelpers.formatDate(new Date(start.body))}`
            }
        }
    }

    getStudent(id = this.state.studentId || this.state.curStudent.id) {
        StudentApiService.get(id)
            .then(res => {
                this.setState({
                    curStudent: res,
                    studentId: res.id,
                    bd: res.bd,
                    showMembershipModal: false
                });

                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        name: res.name,
                        email: res.email,
                        phone: res.phone,
                        note: res.note,
                        address: res.address,
                        dni: res.dni,
                        bd: res.bd,
                        bank: res.bank,
                        inj: res.inj
                    }
                }));

                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getStudentTickets(id = this.state.studentId || this.state.curStudent.id) {
        this.setState(prevState => ({
            curStudent: {
                ...prevState.curStudent,
                tickets: []
            }
        }));

        StudentApiService.get(id)
            .then(res => {
                this.setState({
                    curStudent: res,
                });

                this.setState({isLoading: false, showTickets: true})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    updateStudent(clientId = this.state.curStudent.id) {

        const studentData = {
            name: this.state.formData.name,
            phone: this.state.formData.phone,
            dni: this.state.formData.dni,
            bd: this.state.bd,
            inj: this.state.formData.inj,
            bank: this.state.formData.bank,
            address: this.state.formData.address,
            email: this.state.formData.email,
            note: this.state.formData.note,
            add_email: this.state.formData.add_email,
        };

        StudentApiService.update(clientId, studentData)
            .then(res => {
                this.getStudent()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });

        this.setState({
            profileWasUpdated: false,
        });
    }

    postStudent() {
        this.setState({
            profileWasUpdated: false,
        });

        const studentData = {
            name: this.state.formData.name,
            phone: this.state.formData.phone,
            dni: this.state.formData.dni,
            bd: this.state.bd,
            inj: this.state.formData.inj,
            bank: this.state.formData.bank,
            address: this.state.formData.address,
            email: this.state.formData.email,
            note: this.state.formData.note,
            add_email: this.state.formData.add_email,
        };

        StudentApiService.create(studentData)
            .then(res => {
                this.getStudent(res.id)
            })
            .catch((e) => {
                this.handleNetworkError({message: alertStrings.account_exists_client})
            });
    }

    renderChatView() {
        return <Card className="shadow bg-white" style={sectionStyle}>
            <div style={{color: "black"}}>
                <h4 style={{color: "black", display: "flex", flexFlow: "row", justifyContent: "space-between", alignItems: "center"}}>{resourceStrings.cabinet.messages}
                        <Button style={{marginTop: 20, marginBottom: 20}} size="sm" color="warning"
                                onClick={e => this.toggleMessageHistoryView()}> {this.state.showMessageHistoryView ? commonStrings.close : resourceStrings.cabinet.messaging_app_view_messages} </Button>
                </h4>

                <div
                    style={{color: "gray"}}>{resourceStrings.cabinet.messaging_app_send_one_expl}</div>

                <div ref={this.chatRef}/>

                {this.state.showMessageHistoryView &&
                    <ChatWindow incomingMessages={this.state.messages} student={this.state.curStudent} />
                }
            </div>
        </Card>
    }

    loadMessages() {
        businessApiService.studentMessages(this.state.curStudent.id)
            .then(response => {
                this.setState({messages: response, showMessageHistoryView: true})
                // window.scrollTo(0, 600);
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
    }

    toggleMessageHistoryView = state => {
        if (!this.state.showMessageHistoryView) this.loadMessages()
        else this.setState({
            showMessageHistoryView: !this.state.showMessageHistoryView
        });
    }

    renderTableData() {
        if (this.state.showTickets === true) {
            if (this.state.showMessageHistoryView) this.toggleMessageHistoryView()
            return this.state.curStudent.tickets.map((ticket, index) => {
                return (
                    <TicketTableRow ticket={ticket} key={ticket.id} openTicket={this.openTicket}
                                    deleteTicket={this.confirmDeletion}/>
                )
            })
        } else if (this.state.showClasses === true) {
            return this.state.curStudent.yclasses.map((yclass, index) => {
                return (
                    <ClassTableRow yclass={yclass} key={yclass.id} goToClass={this.goToClass}/>
                )
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.formData !== this.state.formData) {
            this.handleValidation();
        }
    }

    handleValidation() {
        this.validateName();
        this.validateEmail();
    }

    validateName() {
        const name = this.state.formData.name || "";

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: name.length >= 1
            }
        }));
    }

    isHara() {
        return businessHelper.business().id === 52
    }

    validateEmail() {
        const email = this.state.formData.email || "";

        if (this.isHara()) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    email: (email.includes("@") && email.includes("."))
                }
            }));
        } else {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    email: (email.length === 0) || (email.includes("@") && email.includes("."))
                }
            }));
        }
    }

    componentDidMount() {
        if (!localStorage.getItem(constants.open.AUTH_TOKEN) || !localStorage.getItem(constants.open.BUSINESS)) {
            return <Redirect from="*" to="/auth/login"/>
        }

        if (this.state.studentId) {
            this.getStudent()
        }

        if (this.props.location.state.newClientName) {
            this.setState(prevState => ({
                profileWasUpdated: true,
                formData: {
                    ...prevState.formData,
                    name: this.props.location.state.newClientName
                }
            }));
        }

        this.tableRef = React.createRef();
        this.chatRef = React.createRef();
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.studentId !== nextState.studentId) {
            this.getStudent(nextState.studentId)
        }
    }

    getBdDay() {
        let bd = this.state.bd;
        if (bd) {
            if (bd.includes("|")) {
                return bd.split('|')[0];
            } else {
                return "0"
            }
        }
    }

    getBdMonth(b = null) {
        let bd = b ? b : this.state.bd;
        if (bd) {
            if (bd.includes("|")) {
                let m = bd.split('|')[1];

                let index = dateHelpers.months().map(function (o) {
                    return o.value;
                }).indexOf(m);

                if (index !== null) {
                    return dateHelpers.months()[index]
                } else {
                    return null
                }
            } else {
                return null
            }
        }
    }

    handleChange(event) {
        this.setState({
            profileWasUpdated: true,
        });

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        name: newValue
                    }
                }));
                break;
            case "input-message":
                this.setState(prevState => ({
                    newMessage: newValue
                }));
                break;
            case "input-id-number":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        dni: newValue
                    }
                }));
                break;
            case "input-email":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        email: newValue
                    }
                }));
                break;
            case "input-add-email":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        add_email: newValue
                    }
                }));
                break;
            case "input-phone":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        phone: newValue
                    }
                }));
                break;
            case "input-address":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        address: newValue
                    }
                }));
                break;
            case "input-note":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        note: newValue
                    }
                }));
                break;
            case "input-inj":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        inj: newValue
                    }
                }));
                break;
            case "input-bd-day":
                this.updateBd(newValue, null);
                break;
            case "input-pm":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        bank: newValue
                    }
                }));
                break;
            case "input-sm":
                this.setState({smInput: newValue, smInputStarted: true});
                break;
            default:
                return
        }
    }

    updateBd(day = null, month = null) {
        let bd = this.state.bd ? this.state.bd : "";
        if (day !== null) {
            if (bd.includes("|")) {
                month = bd.split("|")[1];
            } else {
                month = 1
            }
        } else {
            if (bd.includes("|")) {
                day = bd.split("|")[0];
            } else {
                day = 1
            }
        }

        bd = day + "|" + month;

        this.setState({
            bd: bd
        })
    }

    onChangeFile(event) {
        this.setState({
            photoLoading: true,
        });
        event.stopPropagation();
        event.preventDefault();
        var file = event.target.files[0];
        console.log(file);
        const blob = URL.createObjectURL(event.target.files[0]);
        // this.setState({
        //     blob: blob
        // });
        this.setState({file}); /// if you want to upload latter
        this.uploadFile(file);
    }

    deletePhoto(student) {
        const task0 = storage.refFromURL(student.photo).delete()

        task0.then(() => {
            this.updateStudentPhoto("")
            console.log("Photo deleted")
        }).catch((error) => {
            console.log(`Firebase error: ${error}`)
            const task1 = storage.ref(`students/${student.created_by}/student_${student.id}`).delete()
            task1.then(() => {
                this.updateStudentPhoto("")
                console.log("Photo deleted")
            }).catch((error) => {
                console.log(error)
                console.log(`Firebase error: ${error}`)
                const task2 = storage.ref(`students/${student.created_by}/student_${student.id}.jpg`).delete()
                task2.then(() => {
                    this.updateStudentPhoto("")
                    console.log("Photo deleted")
                }).catch((error) => {
                    console.log(`Firebase error: ${error}`)
                });
            });
        });
    }

    uploadFile(file) {
        const uploadTask = storage.ref(`students/${businessId}/student_${this.state.studentId}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                // Error function ...
                this.setState({
                    photoLoading: true,
                });
                console.log(error);
            },
            () => {
                // complete function ...
                storage
                    .ref(`students/${businessId}`)
                    .child(`student_${this.state.studentId}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});
                        this.updateStudentPhoto(url);
                    });
            }
        );
    };

    updateStudentPhoto(url) {
        StudentApiService.update(this.state.curStudent.id, {photo: url})
            .then(res => {
                this.setState({photoLoading: false});
                this.getStudent()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleSubmit(event) {
        if (this.state.curStudent !== null) {
            this.updateStudent(this.state.curStudent.id);
        } else {
            this.postStudent();
        }
        event.preventDefault();
    }

    deleteStudentPhoto() {
        this.deletePhoto(businessHelper.business().id, this.state.curStudent)
    }

    render() {
        this.localize();

        if (this.state.goToClassReport) {
            return <Redirect from="*" to={{
                pathname: "/admin/tables",
                state: {reportName: constants.reports.attendanceReport}
            }}/>

        }

        if (this.state.goToUnpaidReport) {
            return <Redirect from="*" to={{
                pathname: "/admin/tables",
                state: {reportName: constants.reports.studentWithUnpaidClassesReport}
            }}/>

        }

        if (this.state.goToClass === true && this.state.goToClassId) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.state.goToClassId}
            }}/>
        }

        if (this.state.backToClients === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/clients",
                state: {
                    searchValue: this.state.searchValue,
                    includeDeletedClients: this.state.includeDeletedClients,
                    filters: this.state.filters
                }
            }}/>
        }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        if (this.state.showTickets === true || this.state.showClasses === true) {
            window.scrollTo(0, this.tableRef.current.offsetTop);
        }

        return (
            <>

                {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                     toggleErrorModal={() => this.toggleErrorModal()}/>}

                {this.state.showDeletionModal && this.state.ticketToDeleteId !== null &&
                    this.renderDeletionModal()
                }

                {this.state.showMergeAlert == true &&
                    this.renderMergeAlert()
                }

                {this.state.showMembershipModal && this.state.membership_popup_type !== null &&
                    this.renderMembershipModal()
                }

                {this.state.showRanksView &&
                    this.renderRanksModal()
                }

                {this.state.showRewardView &&
                    this.renderRewardsModal()
                }

                {this.state.mustShowRegularClasses &&
                    this.renderClassTypeModal()
                }

                {this.state.showQRModal === true &&
                    this.renderQrModal()
                }

                {this.state.showStudentsModal &&
                    this.renderStudentSearchModal()
                }

                <ClientHeader student={this.state.curStudent} backToClass={this.state.backToClass}
                              backToClassReport={this.state.backToClassReport}
                              goToClass={this.goToClass} sendEmail={this.sendEmail}
                              showBackToClientButton={(this.state.searchValue && this.state.searchValue.length > 0) || this.state.filters}
                              backToClients={this.backToClients.bind(this)}
                              showSendQrModal={this.showSendQrModal.bind(this)}
                              manageMembership={this.manageMembership.bind(this)}
                              goToClassReport={this.goToClassReport.bind(this)}
                              goToUnpaidReport={this.goToUnpaidReport.bind(this)}
                              backToUnpaidReport={this.state.backToUnpaidReport}
                />

                {this.state.isLoading &&
                    <RotateCircleLoading color="blue"/>
                }

                {/* Page content */}
                <Container className="mt--7" fluid>
                    <Row>
                        {this.state.curStudent &&
                            // Student info
                            <Col className="order-xl-1 mb-5 mb-xl-0" xl="4">
                                <Card className="card-profile shadow">
                                    <Row className="justify-content-center">
                                        <Col className="order-lg-2" lg="3">
                                            <div className="card-profile-image" onClick={this.handleClick.bind(this)}>
                                                <input type="file" id="file" ref={this.fileRef}
                                                       style={{display: "none"}}
                                                       onChange={this.onChangeFile.bind(this)}/>
                                                <a onClick={e => e.preventDefault()}>
                                                    {this.state.curStudent && this.state.curStudent.photo ? (
                                                        <img
                                                            alt="..."
                                                            style={{objectFit: "cover", imageOrientation: "from-image"}}
                                                            src={this.state.curStudent.photo}
                                                        />
                                                        // <UserAvatar name ="Sam" size="160" src={this.state.curStudent.photo} />
                                                        // <Avatar round={true} src={this.state.curStudent.photo} />
                                                    ) : (
                                                        <img
                                                            alt="..."
                                                            className="rounded-circle"
                                                            src={placeholderHelper.randomIcon()}
                                                        />
                                                    )
                                                    }
                                                </a>
                                            </div>
                                            {this.state.photoLoading &&
                                                <RotateCircleLoading color="white"/>
                                            }
                                        </Col>
                                        {/*<button onClick={this.deleteStudentPhoto}>DELETE PHOTO</button>*/}
                                    </Row>
                                    <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                                        <div className="d-flex justify-content-between">
                                            {(this.state.showClasses === true || this.state.showTickets === true || this.state.showTicketTypeSelector === true) &&
                                                <Button
                                                    className="mr-4"
                                                    color="info"

                                                    onClick={e => this.showEditClient(e)}
                                                    size="sm"
                                                >
                                                    {studentStrings.edit_client}
                                                </Button>
                                            }
                                            {/*<Button*/}
                                            {/*  className="float-right"*/}
                                            {/*  color="default"*/}
                                            {/*  */}
                                            {/*  onClick={e => e.preventDefault()}*/}
                                            {/*  size="sm"*/}
                                            {/*>*/}
                                            {/*  Student notes*/}
                                            {/*</Button>*/}
                                        </div>
                                    </CardHeader>
                                    <CardBody className="pt-0 pt-md-4">
                                        <Row>
                                            <div className="col">
                                                <div
                                                    className="card-profile-stats d-flex justify-content-center mt-md-5">
                                                    <Button
                                                        color="default"
                                                        onClick={(e) => {
                                                            this.showTickets(e)
                                                        }}
                                                    >
                                                    <span
                                                        className="heading">{this.state.curStudent.ticket_count.toString() || "0"}</span>
                                                        <div className="description">{resourceStrings.tickets}</div>
                                                    </Button>
                                                    <Button
                                                        color="default"
                                                        onClick={(e) => {
                                                            this.showClasses(e)
                                                        }}>
                                                    <span
                                                        className="heading">{this.state.curStudent.class_count.toString() || "0"}</span>
                                                        <div className="description">{resourceStrings.classes}</div>
                                                    </Button>
                                                </div>
                                            </div>
                                        </Row>
                                        <div className="text-center">
                                            {this.state.curStudent && this.state.curStudent.name &&
                                                <>
                                                    <h3>
                                                        {this.state.curStudent.name.replace("(archived)", "")}
                                                    </h3>
                                                    <div className="mt--3 mb-2"><small style={{fontSize: "0.5rem"}}>
                                                        {this.createdDate()}
                                                    </small></div>
                                                    <span className="m-1">{this.rewardStatus()}</span>
                                                    <span className="m-1">{this.rankStatus()}</span>
                                                    <span className="m-1">{this.regularClasses()}</span>
                                                    <span className="m-1">{this.unblockStatus()}</span>

                                                    {/* HARA YOGA */}
                                                    {businessHelper.business().id === 52 &&
                                                        <>
                                                            <div className="mb-2 mt-2 text-blue"><small
                                                                style={{fontSize: "0.8rem"}}>
                                                                {this.haraMembershipStart()}
                                                            </small></div>
                                                            <div className="mb-2 mt-2 text-blue"><small
                                                                style={{fontSize: "0.8rem"}}>
                                                                {this.haraMembershipEnd()}
                                                            </small></div>
                                                        </>
                                                    }

                                                    {this.renderSMBar()}
                                                </>
                                            }

                                            <div className="h5 mt-4">
                                                {this.state.curStudent && this.state.curStudent.address ?
                                                    (
                                                        <span> {this.state.curStudent.address}</span>
                                                    ) :
                                                    (<span>
                                                    {/*Address is not set*/}
                                                </span>)
                                                }
                                            </div>
                                            <hr className="my-4"/>
                                            {this.state.curStudent && this.state.curStudent.note ?
                                                (<p>
                                                    {this.state.curStudent.note}
                                                </p>) :
                                                (<p>
                                                    {/*Note is not set*/}
                                                </p>)
                                            }
                                            <Button
                                                size="sm"
                                                className="mt-2"
                                                color="success"
                                                onClick={(e) => {
                                                    this.merge(e)
                                                }}>
                                                {studentStrings.merge_with}
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div> {this.renderChatView()} </div>
                            </Col>
                        }
                        {this.state.showTicketTypeSelector === false && this.state.showTickets === false && this.state.showClasses === false && this.state.showTicketEditor === false && this.state.showTicketTypeEditor === false &&
                            // Student inputs
                            <Col className="order-xl-1" xl="8">
                                <Card className="bg-secondary shadow">
                                    <CardHeader className="bg-white border-0">
                                        <Row className="align-items-center">
                                            <Col xs="8">
                                                <h3 className="mb-0">{studentStrings.client_info}</h3>
                                            </Col>
                                            <Col className="text-right" xs="4">
                                                {this.state.profileWasUpdated &&
                                                    <Button
                                                        color="default"
                                                        disabled={!this.validationCleared()}
                                                        onClick={e => this.handleSubmit(e)}
                                                        size="sm"
                                                    >
                                                        {commonStrings.save}
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Form onSubmit={this.handleSubmit}>
                                            <h6 className="heading-small text-muted mb-4">
                                                {studentStrings.client_info}
                                            </h6>
                                            <div className="pl-lg-4">
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-name"
                                                            >
                                                                {commonStrings.full_name}
                                                            </label>
                                                            <Input
                                                                className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.name ? this.state.curStudent.name.replace("(archived)", "") : this.state.formData.name || ""}
                                                                id="input-name"
                                                                placeholder={commonStrings.full_name}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <label
                                                            className="form-control-label"
                                                            htmlFor="input-email"
                                                        >
                                                            {commonStrings.email}
                                                        </label>
                                                        <FormGroup>
                                                            <Input
                                                                className={this.state.validation.email === true ? "form-control-alternative" : "is-invalid"}
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.email ? this.state.curStudent.email : ''}
                                                                id="input-email"
                                                                placeholder="you@sopenmanagerapp.com"
                                                                type="email"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-address"
                                                            >
                                                                {commonStrings.address}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.address ? this.state.curStudent.address : ""}
                                                                id="input-address"
                                                                placeholder={commonStrings.address_expl}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-last-name"
                                                            >
                                                                {commonStrings.phone}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                id="input-phone"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.phone ? this.state.curStudent.phone : ""}
                                                                placeholder={commonStrings.phone}
                                                                type="tel"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-pm"
                                                            >
                                                                {commonStrings.id_number}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.dni ? this.state.curStudent.dni : ""}
                                                                id="input-id-number"
                                                                placeholder="XXX-00000"
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-pm"
                                                            >
                                                                {commonStrings.payment_method}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                id="input-pm"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.bank ? this.state.curStudent.bank : ""}
                                                                placeholder={commonStrings.payment_method_expl}
                                                                type="tel"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <hr className="my-4"/>
                                            {/* Injuries */}
                                            <div className="pl-lg-4">
                                                <FormGroup>
                                                    <label>{commonStrings.injury_info}</label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-inj"
                                                        placeholder={commonStrings.injury_info_expl}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.curStudent && this.state.curStudent.inj ? this.state.curStudent.inj : ''}
                                                        rows="4"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </div>
                                            <hr className="my-4"/>
                                            {/* Birthday */}
                                            <h6 className="heading-small text-muted mb-4">{commonStrings.birthday}</h6>
                                            <div className="pl-lg-4">
                                                <Row>
                                                    <Col lg="3">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-id-number"
                                                            >
                                                                {commonStrings.day}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.curStudent && this.state.curStudent.bd ? this.getBdDay() : ""}
                                                                id="input-bd-day"
                                                                placeholder=""
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="9">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                            >
                                                                {commonStrings.month}
                                                            </label>
                                                            <Select
                                                                className="form-control-alternative"
                                                                value={this.getBdMonth()}
                                                                placeholder={commonStrings.select}
                                                                onChange={this.handleMonthSelected}
                                                                options={dateHelpers.months()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                            {/* Note */}
                                            <h6 className="heading-small text-muted mb-4">{commonStrings.notes}</h6>
                                            <div className="pl-lg-4">
                                                <FormGroup>
                                                    <label>{commonStrings.note}</label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-note"
                                                        placeholder={commonStrings.note_expl}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.curStudent && this.state.curStudent.note ? this.state.curStudent.note : ''}
                                                        rows="4"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </div>

                                            {/* Addition email */}
                                            <div className="pl-lg-4">
                                                <FormGroup>
                                                    <label>{commonStrings.additional_email_address}</label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-add-email"
                                                        placeholder={commonStrings.email}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.curStudent && this.state.curStudent.add_email ? this.state.curStudent.add_email : ''}
                                                        type="email"
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Form>
                                        <Row className="align-items-end">
                                            <Col className="text-right" xs="12">
                                                {this.state.profileWasUpdated &&
                                                    <Button
                                                        color="default"
                                                        disabled={!this.validationCleared()}
                                                        onClick={e => this.handleSubmit(e)}
                                                        size="lg"
                                                    >
                                                        {commonStrings.save}
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        }
                        {this.state.showTicketTypeEditor === true &&
                            <Col className="order-xl-1" xl="8">
                                <EditTicketTypeView
                                    closeTicketTypeView={this.closeTicketTypeView} handleError={this.handleNetworkError}
                                />
                            </Col>
                        }
                        {this.state.showTicketEditor === true &&
                            <Col className="order-xl-1" xl="8">
                                <Card className="bg-secondary shadow">
                                    <CardHeader className="bg-white border-0">
                                        <Row className="align-items-center">
                                            <Col xs="8">
                                                <h3 className="mb-0">
                                                    <span style={{
                                                        display: 'flex',
                                                        flexFlow: 'row',
                                                        alignItems: 'center'
                                                    }}>
                                                        {this.state.selectedTicketType && this.state.selectedTicketType.name ? this.state.selectedTicketType.name : this.state.ticketTemplate.name || ""}

                                                        {this.state.ticketTemplate && this.state.ticketTemplate.is_workshop_ticket &&
                                                            <label style={{
                                                                marginBottom: 0,
                                                                marginLeft: 4,
                                                                fontSize: "0.6rem",
                                                                color: "white",
                                                                background: "#5D7476",
                                                                paddingLeft: 10,
                                                                paddingRight: 10,
                                                                paddingTop: 4,
                                                                paddingBottom: 4,
                                                                borderRadius: 10
                                                            }}>{resourceStrings.workshop_ticket}
                                                            </label>}
                                                    </span>
                                                </h3>
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <EditTicketView
                                            ticket={this.state.ticketTemplate}
                                            ticketType={this.state.selectedTicketType}
                                            currency={this.state.business.cur.split('-')[1]}
                                            updateTicket={this.updateTicket}
                                            closeTicketView={this.closeTicketView}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        }
                        {this.state.showTicketTypeSelector === true && this.state.ticketTypes &&
                            <Col className="order-xl-1" xl="8">
                                <Card className="bg-secondary shadow">
                                    <CardHeader className="bg-white border-0">
                                        <Row className="align-items-center">
                                            <Col xs="8">
                                                <h3 className="mb-0">{resourceStrings.select_tt}</h3>
                                            </Col>
                                            <div className="col text-right">
                                                <Button
                                                    color="warning"

                                                    onClick={e => this.closeTicketTypeSelector(e)}
                                                    size="sm"
                                                >
                                                    {commonStrings.cancel}
                                                </Button>
                                            </div>

                                            <div className="col text-right">
                                                <Button
                                                    color="secondary"

                                                    onClick={e => this.showAddTicketType(e)}
                                                    size="sm"
                                                >
                                                    {resourceStrings.add_tt}
                                                </Button>
                                            </div>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        {this.state.ticketTypes.filter(tt => !tt.membership).map((tt) => (
                                            <ResourceItem
                                                key={tt.id}
                                                item_name={tt.name}
                                                is_enrolment={tt.is_enrolment}
                                                icon={require("assets/img/icons/common/ticket_white.svg").default}
                                                item_extra={this.state.business.cur.split('-')[1] + " " + tt.price}
                                                onSelected={this.onTicketTypeSelected}
                                            />
                                        ))}
                                    </CardBody>
                                </Card>
                            </Col>
                        }
                        {this.state.showTickets === true &&
                            // Tickets table
                            <Col className="order-xl-1 mt-4" xl="12">
                                <Card className="bg-default shadow">
                                    <CardHeader className="bg-transparent">
                                        <Row>
                                            <h2 className="text-white mb-0">{resourceStrings.tickets}</h2>
                                            <Button
                                                style={{position: "absolute", right: 20, top: 10}}
                                                color="warning"
                                                onClick={e => this.showTicketTypes(e)}
                                                size="lg"
                                            >
                                                {resourceStrings.add_ticket}
                                            </Button>
                                        </Row>
                                    </CardHeader>
                                    <Table
                                        className="align-items-center table-dark table-flush"
                                        responsive
                                    >
                                        <thead className="thead-dark">
                                        <tr>
                                            <th scope="col">{resourceStrings.title}</th>
                                            <th scope="col">ID</th>
                                            <th scope="col">{resourceStrings.status}</th>
                                            <th scope="col">{resourceStrings.valid_until}</th>
                                            <th scope="col">{resourceStrings.classes_amount}</th>
                                            <th scope="col"/>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.renderTableData()}
                                        </tbody>
                                    </Table>
                                </Card>
                            </Col>
                        }
                        {this.state.showClasses === true &&
                            // Tickets table
                            <Col className="order-xl-1 mt-4" xl="12">
                                <Card className="bg-default shadow">
                                    <CardHeader className="bg-transparent">
                                        <h2 className="text-white mb-0">{resourceStrings.classes}</h2>
                                    </CardHeader>
                                    <Table
                                        className="align-items-center table-dark table-flush"
                                        responsive
                                    >
                                        <thead className="thead-dark">
                                        <tr>
                                            <th scope="col">{resourceStrings.title}</th>
                                            <th scope="col">{commonStrings.date}</th>
                                            <th scope="col">{resourceStrings.ticket}</th>
                                            <th scope="col"/>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.renderTableData()}
                                        </tbody>
                                    </Table>
                                </Card>
                            </Col>
                        }
                        <div ref={this.tableRef}/>
                    </Row>
                </Container>
            </>
        );
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    getTicketTypes() {
        this.setState({isLoading: true});
        TicketTypeApiService.index()
            .then(res => {
                this.setState({
                    ticketTypes: res,
                    isLoading: false
                });

                this.ticketTypesSelector()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    closeTicketView(ev) {
        ev.preventDefault();
        this.getStudentTickets()
        this.setState({
            showTicketEditor: false,
            showTickets: false
        })
    }

    closeTicketTypeView(ev) {
        if (ev) {
            ev.preventDefault()
        }

        this.setState({
            showTicketTypeEditor: false,
            showTickets: true
        });

        this.getTicketTypes()
    }

    updateTicket(ticket) {
        this.setState({isLoading: true});

        if (ticket.id) {
            TicketApiService.update(ticket.id, this.state.studentId, ticket)
                .then(res => {
                    this.getStudent();
                    this.setState({
                        showTicketEditor: false,
                        showTickets: false,
                        isLoading: false
                    })

                    this.getStudentTickets()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        } else {
            TicketApiService.create(this.state.studentId, ticket)
                .then(res => {
                    this.getStudent();
                    this.setState({
                        showTicketEditor: false,
                        showTickets: false,
                        isLoading: false
                    })
                    this.getStudentTickets()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    showTicketTypes(e) {
        if (e !== null) {
            e.preventDefault();
        }
        if (this.state.ticketTypes === null) {
            this.getTicketTypes();
        } else {
            this.ticketTypesSelector()
        }
    }

    ticketTypesSelector() {
        this.setState({
            showTicketTypeSelector: true,
            showClasses: false,
            showTickets: false,
        });
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        studentStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    goToClass(id) {
        this.setState({goToClass: true, goToClassId: id})
    }

    toggleDeletionModal = state => {
        this.setState({
            showDeletionModal: !this.state.showDeletionModal
        });
    };

    toggleMergeModal = state => {
        this.setState({
            showMergeAlert: !this.state.showMergeAlert
        });
    };

    toggleStudentsModal = state => {
        this.setState({
            showStudentsModal: !this.state.showStudentsModal
        });
    };

    onAnotherStudentSelected(partner) {
        this.setState(prevState => ({
            showStudentsModal: false,
            showMergeAlert: true,
            selectedAnotherStudent: partner
        }));
    }

    startMerge(e) {
        this.setState({showMergeAlert: false})
        if (this.state.studentId != this.state.selectedAnotherStudent.id) {
            e.preventDefault();

            this.setState({isLoading: true})
            StudentApiService.mergeWithAnother(this.state.studentId, this.state.selectedAnotherStudent.id)
                .then(res => {
                    this.getStudent();
                })
                .finally(
                    this.setState({isLoading: true})
                )
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    renderStudentSearchModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showStudentsModal}
                toggle={() => this.toggleStudentsModal()}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modal-title-notification">
                                {/*Your attention is required*/}
                            </h6>
                            <button
                                aria-label="Close"
                                className="close"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => this.toggleStudentsModal()}
                            >
                                <span aria-hidden={true}>×</span>
                            </button>
                        </div>

                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.invoices.select_client}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <PartnerSearch
                                closeStudentSearchView={this.closeStudentSearchView.bind(this)}
                                addStudent={this.onAnotherStudentSelected.bind(this)}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    closeStudentSearchView(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            showStudentsModal: false
        });
    }

    merge(e) {
        e.preventDefault();
        this.setState({showStudentsModal: true})
    };

    renderDeletionModal() {
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={this.state.showDeletionModal}
                toggle={() => this.toggleDeletionModal("notificationModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleDeletionModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <MdDelete size="50px"/>
                        {alertStrings.confirmation_alert_title}
                        <p>
                            {alertStrings.confirm_delete_ticket}
                        </p>
                        {this.isActiveMembershipTicket(this.state.ticketToDeleteId) &&
                            <p>
                                {resourceStrings.memberships.deleting_membership_ticket}
                            </p>
                        }
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.deleteTicket}>
                            {alertStrings.yes}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.toggleDeletionModal}>
                            {alertStrings.no}
                        </Button>

                    </Col>
                </div>
            </Modal>
        )
    }

    renderMergeAlert() {
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={this.state.showMergeAlert}
                toggle={() => this.toggleMergeModal()}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleMergeModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <MdCallMerge size="50px"/>
                        <p>
                            {alertStrings.confirm_merge_students}
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={e => this.startMerge(e)}>
                            {alertStrings.yes}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.toggleMergeModal}>
                            {alertStrings.no}
                        </Button>

                    </Col>
                </div>
            </Modal>
        )
    }

    showAddTicketType(e) {
        e.preventDefault();

        this.setState({showTicketTypeEditor: true, showTicketTypeSelector: false});

    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, photoLoading: false})
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    backToClients(e) {
        e.preventDefault();
        this.setState({backToClients: true})
    }

    createdDate() {
        return `${studentStrings.client_since}: ${dateHelpers.formatDate(new Date(this.state.curStudent.created_at))}`
    }

    rankStatus() {
        return <div>
            <Button
                color="secondary"
                size="sm"
                style={{minWidth: 200}}
                onClick={(e) => {
                    this.showRanksView(e)
                }}>
                {this.renderStudentRanks()}
            </Button>
        </div>
    }

    unblockStatus() {
        return <div>
            <span>
            {!this.state.curStudent.can_book ?
                (<span>
                        <Button
                            color="danger"
                            size="sm"
                            style={{minWidth: 200, margin: 0}}
                            onClick={(e) => {
                                this.unblock(e)
                            }}>
                        {studentStrings.unblock}
                    </Button>
                <div className="small" style={{color: "red"}}>{studentStrings.canc_limit_reached}</div>
                    </span>
                ) : (<span/>)
            }
            </span>
        </div>
    }

    regularClasses() {
        return <div>
            <span>
                <Button
                    color="secondary"
                    size="sm"
                    style={{minWidth: 200, margin: 0}}
                    onClick={(e) => {
                        this.showRegularClasses(e)
                    }}>
                {studentStrings.regular_classes}
                </Button>
            </span>
        </div>
    }

    unblock(e) {
        e.preventDefault();
        StudentApiService.unblock(this.state.curStudent.id)
            .then(() => {
                this.getStudent()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    rewardStatus() {
        return <div style={centerAll}>
            <Button
                size="sm"
                style={{display: "flex", minWidth: 200, justifyContent: "center"}}
                color="secondary"
                onClick={(e) => {
                    this.showRewardView(e)
                }}>
                {this.renderStudentRewards()}
            </Button>
        </div>
    }

    rankIcon(rank) {
        function makeIcon(rank) {
            if (rank && rank.icon && rank.icon.length > 0)
                return require(`assets/img/icons/ranks/${rank.icon}/${rank.icon}-${rank.color}.svg`);
        }

        return rank.icon ?
            <img
                style={{marginRight: '0.5rem'}}
                width={18}
                height={18}
                alt=""
                src={makeIcon(rank)}
            /> : null
    }

    rewardIcon(reward) {
        function makeIcon(reward) {
            if (reward && reward.icon)
                return require(`assets/img/icons/rewards/${reward.icon}.svg`);
        }

        return reward.icon ?
            <img
                style={{margin: "2px"}}
                width={24}
                height={24}
                alt=""
                src={makeIcon(reward).default}
            /> : null
    }

    showRanksView(e) {
        e.preventDefault();
        this.setState({showRanksView: true})
    }

    showRewardView(e) {
        if (e) e.preventDefault();
        if (this.state.rewards) {
            this.setState({showRewardView: true})
        } else this.getRewards()
    }

    getRewards = () => {
        this.setState({isLoading: true})

        businessApiService.rewards()
            .then(res => {
                this.setState({
                    isLoading: false,
                    rewards: res.rewards || [],
                    classTypes: res.class_types,
                    showRewardView: true,
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getClassTypes = () => {
        this.setState({isLoading: true})

        resourceApiService.classTypes()
            .then(res => {
                this.setState({
                    isLoading: false,
                    classTypes: res,
                    mustShowRegularClasses: true,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    toggleRanksModal = state => {
        this.setState({
            showRanksView: !this.state.showRanksView
        });

        if (this.state.showRanksView) this.getStudent()
    };

    renderRanksModal() {
        return (
            <Modal
                className="modal-dialog-centered bg-default"
                size="lg"
                isOpen={this.state.showRanksView}
                toggle={() => this.toggleRanksModal("formModal")}
            >
                <div className="modal-header bg-default">
                    <h4 className="text-white">
                        {commonStrings.manage_ranks}
                    </h4>
                    <button
                        aria-label="Close"
                        className="close text-white"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleRanksModal()}
                    >
                        <span aria-hidden={true} style={{color: "white"}}>×</span>
                    </button>
                </div>
                <div className="modal-body p-0">
                    <Card className="bg-default shadow border-0">
                        <CardBody className="px-lg-5 mb-5 mt-0">
                            <RanksOverview
                                studentId={this.state.studentId}
                                studentRanks={this.state.curStudent.student_ranks || [resourceHelper.emptyRank()]}
                                onStudentRankUpdated={this.onStudentRankUpdated.bind(this)}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    toggleRewardModal = state => {
        this.setState({
            showRewardView: !this.state.showRewardView
        });
    };

    renderRewardsModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showRewardView}
                toggle={() => this.toggleRewardModal("formModal")}
            >
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-notification">
                        {commonStrings.manage_rewards}
                    </h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleRewardModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardBody className="px-lg-5 mb-5 mt-0">
                            <RewardOverview
                                onRewardsUpdated={this.onRewardsUpdated}
                                rewards={this.state.rewards} classTypes={this.state.classTypes}
                                studentId={this.state.studentId}
                                studentRewards={this.state.curStudent.rewards || [resourceHelper.emptyReward()]}
                                onStudentRewardUpdated={this.onStudentRewardUpdated.bind(this)}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )

    }

    onStudentRankUpdated(student) {
        this.setState({curStudent: student, showRanksView: false})
    }

    onStudentRewardUpdated(student) {
        this.setState({curStudent: student, showRewardView: false})
    }

    renderStudentRanks() {
        if (this.state.curStudent.student_ranks && this.state.curStudent.student_ranks.length > 0) {
            return this.state.curStudent.student_ranks.map((rank, index) => {
                return (
                    <div key={rank.id}>{this.rankIcon(rank)}{rank.title}</div>
                )
            })
        } else return commonStrings.assign_rank
    }

    renderStudentRewards() {
        if (this.state.curStudent.rewards && this.state.curStudent.rewards.length > 0) {
            return this.state.curStudent.rewards.map((reward, index) => {
                return (
                    <Row>
                        <Col style={centerAll}>{this.rewardIcon(reward)}</Col>
                    </Row>
                )
            })
        } else return <span><img
            className="mr-1"
            width={24}
            height={24}
            alt="pm"
            src={require("assets/img/icons/rewards/069-medal-20.svg").default}
        />
            {
                commonStrings.assign_reward
            }
        </span>
    }

    onRewardsUpdated = (rewards) => {
        this.setState({rewards: rewards})
    }

    renderSMBar() {
        return <>
            <Row className="mt-6">
                <Col className="text-right">
                    <Button className="btn-icon align-content-center" color="secondary"
                            onClick={() => this.showSmEditor("fb")}
                            style={{
                                padding: 0,
                                textAlign: "center",
                                width: 24,
                                height: 24
                            }}>
                              <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={this.hasSMLink("fb") ? require("assets/img/icons/sm/facebook.svg").default : require("assets/img/icons/sm/facebook_outline.svg").default}
                                />
                              </span>
                    </Button>

                </Col>

                <Col>
                    <Button className="btn-icon align-content-center" color="secondary"
                            onClick={() => this.showSmEditor("insta")}
                            style={{
                                padding: 0,
                                textAlign: "center",
                                width: 24,
                                height: 24
                            }}>
                              <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={this.hasSMLink("insta") ? require("assets/img/icons/sm/instagram.svg").default : require("assets/img/icons/sm/instagram_outline.svg").default}
                                />
                              </span>
                    </Button>

                </Col>

                <Col className="text-left">
                    <Button className="btn-icon align-content-center" color="secondary"
                            onClick={() => this.showSmEditor("twitter")}
                            style={{
                                padding: 0,
                                textAlign: "center",
                                width: 24,
                                height: 24
                            }}>
                              <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={this.hasSMLink("twitter") ? require("assets/img/icons/sm/twitter.svg").default : require("assets/img/icons/sm/twitter_outline.svg").default}
                                />
                              </span>
                    </Button>

                </Col>
            </Row>

            {this.state.showSmInput === true &&
                <Row className="mt-4">
                    <Col lg="12">
                        <FormGroup>
                            <InputGroup>
                                <Input
                                    onChange={this.handleChange}
                                    value={this.state.smInput}
                                    id="input-sm"
                                    placeholder="www.facebook.com/openmanagerapp"
                                    type="text"
                                />

                                {this.state.smInput &&
                                    <InputGroupAddon addonType="append" onClick={e => this.openSmLink(e)}>
                                        <InputGroupText>
                                            <i className="fas fa-arrow-circle-right text-default"/>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                }
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
            }
            <Row>
                {this.state.smInputStarted &&
                    <Col lg="12">
                        <Button
                            onClick={this.saveSm.bind(this)}
                            color="warning">
                      <span className="btn-inner--icon">
                        {commonStrings.save}
                      </span>
                        </Button>
                    </Col>
                }
            </Row>
        </>
    }

    saveSm() {
        this.setState({smInputStarted: false, showSmInput: false});
        let smData = {};
        switch (this.state.selectedSM) {
            case "fb":
                smData = {type: "note_fb", url: this.state.smInput, id: this.state.studentId};
                break;
            case "twitter":
                smData = {type: "note_twitter", url: this.state.smInput, id: this.state.studentId};
                break;
            case "insta":
                smData = {type: "note_insta", url: this.state.smInput, id: this.state.studentId};
                break;
            default:
                break;
        }

        StudentApiService.updateSM(smData)
            .then(res => {
                this.getStudent();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showSmEditor(type) {
        let data;
        switch (type) {
            case "fb":
                data = this.getSMText("fb") || "";
                break;
            case "twitter":
                data = this.getSMText("twitter") || "";
                break;
            case "insta":
                data = this.getSMText("insta") || "";
                break;
            default:
                data = "";
                break;
        }
        this.setState({showSmInput: true, smInput: data, smInputStarted: false, selectedSM: type})
    }

    hasSMLink(type) {
        if (!this.state.curStudent.student_notes) return false
        else {
            const smData = this.state.curStudent.student_notes.find(it => it.note_type === `note_${type}`)
            return smData && smData.url
        }
    }

    getSMText(type) {
        if (!this.state.curStudent.student_notes) return false
        else {
            const smData = this.state.curStudent.student_notes.find(it => it.note_type === `note_${type}`)
            return smData ? smData.url : ""
        }

    }

    openSmLink(e) {
        e.preventDefault();

        if (this.state.smInput) window.open(this.state.smInput || "", "_blank")
        else return null
    }

    // SEND QR CODE

    sendQrAction(e) {
        e.preventDefault();

        this.setState({isLoading: true, showQRModal: false})

        StudentApiService.sendWelcome(this.state.studentId)
            .then(res => {
                this.getStudent();
                this.setState({
                    isLoading: false
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showSendQrModal(e) {
        e.preventDefault();
        this.setState({showQRModal: true})
    }

    manageMembership(e) {
        e.preventDefault();

        if (this.state.curStudent.is_member) {
            this.showCancellationPopup()
        } else {
            this.showAddMembershipPopup()
        }
        //this.setState({showQRModal: true})
    }

    showAddMembershipPopup() {
        this.setState({showMembershipModal: true, membership_popup_type: "add"})
    }

    showCancellationPopup() {
        this.setState({showMembershipModal: true, membership_popup_type: "cancel"})
    }

    cancelMembership() {
        StudentApiService.cancelMembership(this.state.studentId)
            .then(res => {
                this.setState({
                    isLoading: false
                })

                if (res.message == "success") {
                    this.showMembershipCancelledSuccess()
                } else {
                    this.showMembershipCancelledFailure()
                }
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showMembershipCancelledSuccess() {
        this.setState({showMembershipModal: true, membership_popup_type: "cancelled_success"})
    }

    showMembershipCancelledFailure() {
        this.setState({showMembershipModal: true, membership_popup_type: "failure"})
    }

    toggleQRModal = state => {
        this.setState({
            showQRModal: !this.state.showQRModal
        });
    };

    toggleMembershipModal = state => {
        this.setState({
            showMembershipModal: !this.state.showMembershipModal
        });
    };

    toggleRegularClassesModal = state => {
        this.setState({
            mustShowRegularClasses: !this.state.mustShowRegularClasses
        });
    };

    renderQrModal() {
        return (<Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={this.state.showQRModal}
            toggle={() => this.toggleQRModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleQRModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-qrcode"/>
                    <h4 className="heading mt-4">{commonStrings.send_qr_to_client}</h4>
                    <p>
                        {commonStrings.send_qr_to_client_expl}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleQRModal("notificationModal")}
                >
                    {commonStrings.cancel}
                </Button>
                <Button className="btn-white" color="default" type="button"
                        onClick={e => this.sendQrAction(e)}>
                    {commonStrings.send}
                </Button>
            </div>
        </Modal>)
    }

    renderMembershipModal() {
        return (<Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={this.state.showMembershipModal}
            toggle={() => this.toggleMembershipModal("membershipModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleMembershipModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        width={40}
                        height={40}
                        alt="pm"
                        src={require("assets/img/icons/membership.svg").default}
                    />
                    <h4 className="heading mt-4">{this.getMembershipPopupTitleText()}</h4>
                    <p>
                        {this.getMembershipPopupBodyText()}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.getStudent()}
                >
                    OK
                </Button>
                {this.renderMembershipActionButton()}
            </div>
        </Modal>)
    }

    renderClassTypeModal() {
        return (<Modal
            className="modal-dialog-centered"
            isOpen={this.state.mustShowRegularClasses}
            toggle={() => this.toggleRegularClassesModal("")}
        >
            <div className="modal-header">
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleRegularClassesModal("")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body p-0">
                <CardBody className="px-lg-5 mb-5 mt-0">
                    <RegularClassTypes
                        classTypes={this.state.classTypes}
                        student={this.state.curStudent}
                        onClassTypesUpdated={this.onClassTypesUpdated.bind(this)}
                    />
                </CardBody>
            </div>
        </Modal>)
    }

    onClassTypesUpdated() {
        this.getClassTypes()
    }

    renderMembershipActionButton() {
        switch (this.state.membership_popup_type) {
            case "cancel":
                return (<Button className="btn-white" color="default" type="button"
                                onClick={e => this.cancelMembership(e)}>
                    {resourceStrings.subscriptions.proceed}
                </Button>)
            case "add":
                return null
            case "added_success":
                return null
            case "cancelled_success":
                return null
            case "failure":
                return null
            default:
                return null
        }
    }

    getMembershipPopupTitleText() {
        switch (this.state.membership_popup_type) {
            case "cancel":
                return resourceStrings.memberships.cancel + "?"
            case "add":
                return resourceStrings.memberships.add + "?"
            case "added_success":
                return alertStrings.success
            case "cancelled_success":
                return alertStrings.success
            case "failure":
                return alertStrings.generic_error_title
            default:
                return null
        }
    }

    getMembershipPopupBodyText() {
        switch (this.state.membership_popup_type) {
            case "cancel":
                return resourceStrings.memberships.cancel_expl
            case "add":
                return resourceStrings.memberships.add_expl
            case "added_success":
                return resourceStrings.memberships.added_expl
            case "cancelled_success":
                return resourceStrings.memberships.cancelled_expl
            case "failure":
                return alertStrings.generic_error
            default:
                return null
        }
    }

    isActiveMembershipTicket(ticketToDeleteId) {
        const ticket = this.state.curStudent.tickets.find(t => t.id === ticketToDeleteId);
        if (ticket) {
            return ticket.membership && ticket.subscription_status && ticket.subscription_status != "cancelled"
        } else return false
    }

    showRegularClasses(e) {
        e.preventDefault();

        if (this.state.classTypes) {
            this.setState({mustShowRegularClasses: true});
        } else {
            this.getClassTypes();
        }
    }

}

export default Student;
